import '../Styles/UMAPStyles.css';
import { Component } from 'preact';
import Form from 'react-bootstrap/Form';
import { index } from 'd3';
import Checkbox from 'preact-material-components/Checkbox';
import Formfield from 'preact-material-components/FormField';
import 'preact-material-components/Checkbox/style.css';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import createScatterplot from 'regl-scatterplot';

function sortPoints(datos){

  const scale = 0.05;
  const cantCubes=20;
  let index = 0;
  let cuadr;
  let arrayCuad = [];
  let celda;
  let grilla=[];
  let fila=[];
  let cuad;
  let array=[];

  //Creo la grilla de objetos para almacenar los puntos
  for(let j = 0 ;  j< cantCubes ; j ++){
    for(let i = 0; i < cantCubes ; i ++){
      celda = {i : i, j: j, cantPoints:0,points:[]};
      fila.push(celda);
    }
    grilla.push(fila);
    fila=[];
  }

  let i=0;
  let j=0;

  while(index < datos.length){
    //Calculo i del punto
    i = parseInt(datos[index].umap1 / scale);
    j = parseInt(datos[index].umap2 / scale);

    if( i<cantCubes && j<cantCubes){
      grilla[i][j].cantPoints = grilla[i][j].cantPoints + 1;
        array = grilla[i][j].points;
        array.push(datos[index]);
        grilla[i][j].points = array;

    }
    index++;
  }

  array = [];
  let cant =0;

  for(let j = 0 ;  j< cantCubes ; j ++){
    for(let i = 0; i < cantCubes ; i ++){
      array.push(grilla[j][i]);
      cant = cant + grilla[j][i].cantPoints;
    }
  }

  //Ordena los cubos de mayor a menor segun la cantidad de puntos que caen dentro
  let tmp;
  for (let x = 0; x < array.length; x++) {
    for (let i = 0; i < array.length - x - 1; i++) {
      if (array[i].cantPoints < array[i + 1].cantPoints) {
        tmp = array[i + 1];
        array[i + 1] = array[i];
        array[i] = tmp;
      }
    }
  }
  let arrayTemp = []
  for(let i=0;i< array.length;i++){
    for(let index=0;index < array[i].cantPoints;index++){
      arrayTemp.push(array[i].points[index]);
    }
  }
  return arrayTemp;
}

function subDataFunction(datos,percentile){
  let cantSubData = parseInt((datos.length * percentile) / 100);
  let dataReturn = [];
  let k = 0;

  while (k < datos.length && k <= cantSubData) {
    dataReturn.push(datos[k]);
    k++;
  }
  return dataReturn;
}

function MarchingSquares2D(datos, percentile) {
  const cantCubes=20;
  const scale = 0.05;
  let encontre = false;
  let index = 0;
  let cuadr;
  let arrayCuad = [];
  let x1 = 0;
  let x2 = 0;
  let y1 = 0;
  let y2 = 0;
  let punto1 =  false;
  let punto2 =  false;
  let punto3 =  false;
  let punto4 =  false;
  let punto1Coord=[];
  let punto2Coord=[];
  let punto3Coord=[];
  let punto4Coord=[];

  let celda;
  let grilla=[];
  let fila=[];
  let cuad;

  //Creo la grilla de objetos para almacenar los puntos
  for(let j = 0 ;  j< cantCubes ; j ++){
    for(let i = 0; i < cantCubes ; i ++){
      x1 = i * Number(scale);
      x2 = Number(x1) + Number(scale);
      y1 = j * Number(scale);
      y2 = Number(y1) + Number(scale);
      celda = {i : i, j: j, punto1:0,punto2:0,punto3:0,punto4:0,
                 punto1Coord:[x1,y1],punto2Coord:[x2,y1],punto3Coord:[x1,y2],punto4Coord:[x2,y2]};
      fila.push(celda);
    }
    grilla.push(fila);
    fila=[];
  }

  let i=0;
  let j=0;
  let x=0;
  let y=0;
  while(index < datos.length){

    x=datos[index].umap1;
    y=datos[index].umap2;
    //Calculo i del punto
    i = parseInt(x/scale);
    j = parseInt(y/scale);

    //por el redondeo hacia arriba
    if(j==cantCubes){
      j=cantCubes-1;
    }

    //por el redondeo hacia arriba
    if(i==cantCubes){
      i=cantCubes-1;
    }

    if(i<cantCubes && j<cantCubes){
      x1 = i * Number(scale);
      x2 = Number(x1) + Number(scale);
      y1 = j * Number(scale);
      y2 = Number(y1) + Number(scale);

      //Los puntos extremos del cuadrante son: (x1,y1),(x2,y1),(x1,y2),(x2,y2)

      if(x >= x1 && x <= x2 && y >= y1 && y <= y2  ){

        if(x >= grilla[j][i].punto1Coord[0]-scale/2 &&  x <= grilla[j][i].punto1Coord[0]+scale/2 &&
              y >= grilla[j][i].punto1Coord[1]-scale/2 &&  y <= grilla[j][i].punto1Coord[1]+scale/2 )
          grilla[j][i].punto1 = grilla[j][i].punto1 + 1;

        if(x >= grilla[j][i].punto2Coord[0]-scale/2 &&  x <= grilla[j][i].punto2Coord[0]+scale/2 &&
                y >= grilla[j][i].punto2Coord[1]-scale/2 &&  y <= grilla[j][i].punto2Coord[1]+scale/2 )
            grilla[j][i].punto2 = grilla[j][i].punto2 + 1;

        if(x >= grilla[j][i].punto3Coord[0]-scale/2 &&  x <= grilla[j][i].punto3Coord[0]+scale/2 &&
                y >= grilla[j][i].punto3Coord[1]-scale/2 &&  y <= grilla[j][i].punto3Coord[1]+scale/2 )
            grilla[j][i].punto3 = grilla[j][i].punto3 + 1;

        if(x >= grilla[j][i].punto4Coord[0]-scale/2 &&  x <= grilla[j][i].punto4Coord[0]+scale/2 &&
                y >= grilla[j][i].punto4Coord[1]-scale/2 &&  y <= grilla[j][i].punto4Coord[1]+scale/2 )
        grilla[j][i].punto4 = grilla[j][i].punto4 + 1;
        encontre = true;

        if(!(i==0)){
          //a
          if(x >= grilla[j][i-1].punto2Coord[0]-scale/2 &&  x <= grilla[j][i-1].punto2Coord[0]+scale/2 &&
                  y >= grilla[j][i-1].punto2Coord[1]-scale/2 &&  y <= grilla[j][i-1].punto2Coord[1]+scale/2 ){
                grilla[j][i-1].punto2 = grilla[j][i-1].punto2 + 1;
          }
          if(x >= grilla[j][i-1].punto4Coord[0]-scale/2 &&  x <= grilla[j][i-1].punto4Coord[0]+scale/2 &&
                  y >= grilla[j][i-1].punto4Coord[1]-scale/2 &&  y <= grilla[j][i-1].punto4Coord[1]+scale/2 ){
                grilla[j][i-1].punto4 = grilla[j][i-1].punto4 + 1;
          }

          if(!(i===0) && !(j===cantCubes-1)){
            // B
            if(x >= grilla[j+1][i-1].punto2Coord[0]-scale/2 &&  x <= grilla[j+1][i-1].punto2Coord[0]+scale/2 &&
                    y >= grilla[j+1][i-1].punto2Coord[1]-scale/2 &&  y <= grilla[j+1][i-1].punto2Coord[1]+scale/2 ){
                grilla[j+1][i-1].punto2 = grilla[j+1][i-1].punto2 + 1;
            }
          }
        }

        if(!(j==cantCubes-1)){
          // C
          if(x >= grilla[j+1][i].punto1Coord[0]-scale/2 &&  x <= grilla[j+1][i].punto1Coord[0]+scale/2 &&
                  y >= grilla[j+1][i].punto1Coord[1]-scale/2 &&  y <= grilla[j+1][i].punto1Coord[1]+scale/2 ){
               grilla[j+1][i].punto1 = grilla[j+1][i].punto1 + 1;
          }
          if(x >= grilla[j+1][i].punto2Coord[0]-scale/2 &&  x <= grilla[j+1][i].punto2Coord[0]+scale/2 &&
                  y >= grilla[j+1][i].punto2Coord[1]-scale/2 &&  y <= grilla[j+1][i].punto2Coord[1]+scale/2 ){
              grilla[j+1][i].punto2 = grilla[j+1][i].punto2 + 1;
          }
        }
        if(!(i==cantCubes-1)){
          //e
          if(x >= grilla[j][i+1].punto1Coord[0]-scale/2 &&  x <= grilla[j][i+1].punto1Coord[0]+scale/2 &&
                  y >= grilla[j][i+1].punto1Coord[1]-scale/2 &&  y <= grilla[j][i+1].punto1Coord[1]+scale/2 ){
              grilla[j][i+1].punto1 = grilla[j][i+1].punto1 + 1;
          }

          if(x >= grilla[j][i+1].punto3Coord[0]-scale/2 &&  x <= grilla[j][i+1].punto3Coord[0]+scale/2 &&
                  y >= grilla[j][i+1].punto3Coord[1]-scale/2 &&  y <= grilla[j][i+1].punto3Coord[1]+scale/2 ){
              grilla[j][i+1].punto3 = grilla[j][i+1].punto3 + 1;
          }

          if(!(i==cantCubes-1) && !(j==cantCubes-1)){
            //d
            if(x >= grilla[j+1][i+1].punto1Coord[0]-scale/2 &&  x <= grilla[j+1][i+1].punto1Coord[0]+scale/2 &&
                  y >= grilla[j+1][i+1].punto1Coord[1]-scale/2 &&  y <= grilla[j+1][i+1].punto1Coord[1]+scale/2 ){
                grilla[j+1][i+1].punto1 = grilla[j+1][i+1].punto1 + 1;
            }
          }

          if(!(i==cantCubes-1) && !(j==0)){
            //f
            if(x >= grilla[j-1][i+1].punto3Coord[0]-scale/2 &&  x <= grilla[j-1][i+1].punto3Coord[0]+scale/2 &&
                  y >= grilla[j-1][i+1].punto3Coord[1]-scale/2 &&  y <= grilla[j-1][i+1].punto3Coord[1]+scale/2 ){
                  grilla[j-1][i+1].punto3 = grilla[j-1][i+1].punto3 + 1;
            }
          }
        }

        if(!(j==0)){
          //g
          if(x >= grilla[j-1][i].punto3Coord[0]-scale/2 &&  x <= grilla[j-1][i].punto3Coord[0]+scale/2 &&
                y >= grilla[j-1][i].punto3Coord[1]-scale/2 &&  y <= grilla[j-1][i].punto3Coord[1]+scale/2 ){
              grilla[j-1][i].punto3 = grilla[j-1][i].punto3 + 1;
          }

          if(x >= grilla[j-1][i].punto4Coord[0]-scale/2 &&  x <= grilla[j-1][i].punto4Coord[0]+scale/2 &&
                y >= grilla[j-1][i].punto4Coord[1]-scale/2 &&  y <= grilla[j-1][i].punto4Coord[1]+scale/2 ){
              grilla[j-1][i].punto4 = grilla[j-1][i].punto4 + 1;
          }

          if(!(j==0) && !(i==0)){
            //h
            if(x >= grilla[j-1][i-1].punto4Coord[0]-scale/2 &&  x <= grilla[j-1][i-1].punto4Coord[0]+scale/2 &&
                  y >= grilla[j-1][i-1].punto4Coord[1]-scale/2 &&  y <= grilla[j-1][i-1].punto4Coord[1]+scale/2 ){
                grilla[j-1][i-1].punto4 = grilla[j-1][i-1].punto4 + 1;
            }
          }
        }
      }
    }
    index++;
  }

  let caseCelda;

  for(let i=0 ; i< cantCubes; i++){
    for(let j=0; j< cantCubes;j++){
      if(grilla[j][i].punto1 < 1 && grilla[j][i].punto2 < 1 && grilla[j][i].punto3 < 1  && grilla[j][i].punto4< 1 ){
      }
      else{
        caseCelda = topologicalState(grilla[j][i]);
        arrayCuad.push(caseCelda);
      }
    }
  }
  return arrayCuad;
}

function topologicalState(celda){

  let caseCelda;

  //Case 0
  if(celda.punto1<1 && celda.punto2<1 && celda.punto3<1 && celda.punto4<1){
    caseCelda={type:0,case:0,i:celda.i,j:celda.j, polygonCoord:[]};
  }
  else{
    //Case 1
    if(celda.punto1>0 && celda.punto2<1 && celda.punto3<1 && celda.punto4<1){
      caseCelda={type:1,case:1,i:celda.i,j:celda.j, polygonCoord:[[celda.punto1Coord[0],celda.punto1Coord[1]],
                                       [(celda.punto2Coord[0] - celda.punto1Coord[0]) /2 + celda.punto1Coord[0],celda.punto1Coord[1]],
                                       [celda.punto1Coord[0],(celda.punto3Coord[1] - celda.punto1Coord[1]) /2 + celda.punto1Coord[1]]]};
    }
    else{
      //Case 2
      if(celda.punto1<1 && celda.punto2>0 && celda.punto3<1 && celda.punto4<1){
        caseCelda={type:1,case:2,i:celda.i,j:celda.j, polygonCoord:[[(celda.punto2Coord[0] - celda.punto1Coord[0]) /2 + celda.punto1Coord[0],celda.punto1Coord[1]],
                                         [celda.punto2Coord[0],celda.punto2Coord[1]],
                                         [celda.punto2Coord[0],(celda.punto4Coord[1] - celda.punto2Coord[1]) /2 + celda.punto2Coord[1]]]};
      }
      else{
        //Case 3
        if(celda.punto1>0 && celda.punto2>0 && celda.punto3<1 && celda.punto4<1){
          caseCelda={type:1,case:3, i:celda.i,j:celda.j, polygonCoord:[[celda.punto1Coord[0],celda.punto1Coord[1]],
                                           [celda.punto2Coord[0],celda.punto2Coord[1]],
                                           [celda.punto2Coord[0],(celda.punto4Coord[1] - celda.punto2Coord[1]) /2 + celda.punto2Coord[1]],
                                           [celda.punto1Coord[0],(celda.punto3Coord[1] - celda.punto1Coord[1]) /2 + celda.punto1Coord[1]]]};
        }
        else{
          //Case 4
          if(celda.punto1<1 && celda.punto2<1 && celda.punto3<1 && celda.punto4>0){
            caseCelda={type:1,case:4,i:celda.i,j:celda.j, polygonCoord:[[celda.punto2Coord[0],(celda.punto4Coord[1] - celda.punto2Coord[1]) /2 + celda.punto2Coord[1]],
                                            [celda.punto4Coord[0],celda.punto4Coord[1]],
                                             [(celda.punto4Coord[0] - celda.punto3Coord[0]) /2 + celda.punto3Coord[0],celda.punto3Coord[1]]]};
          }
          else{
            //Case 5
            if(celda.punto1>0 && celda.punto2<1 && celda.punto3<1 && celda.punto4>0){
              caseCelda={type:2,case:5,i:celda.i,j:celda.j, polygonCoord:[[celda.punto1Coord[0],celda.punto1Coord[1]],
                                               [(celda.punto2Coord[0] - celda.punto1Coord[0]) /2 + celda.punto1Coord[0],celda.punto1Coord[1]],
                                               [celda.punto1Coord[0],(celda.punto3Coord[1] - celda.punto1Coord[1]) /2 + celda.punto1Coord[1]]],
                                polygonCoord2:[[(celda.punto4Coord[0] - celda.punto3Coord[0]) /2 + celda.punto3Coord[0],celda.punto3Coord[1]],
                                               [celda.punto2Coord[0],(celda.punto4Coord[1] - celda.punto2Coord[1]) /2 + celda.punto2Coord[1]],
                                             [celda.punto4Coord[0],celda.punto4Coord[1]]]};
            }
            else{
              //Case 6
              if(celda.punto1<1 && celda.punto2>0 && celda.punto3<1 && celda.punto4>0){
                caseCelda={type:1,case:6,i:celda.i,j:celda.j, polygonCoord:[[(celda.punto2Coord[0] - celda.punto1Coord[0]) /2 + celda.punto1Coord[0],celda.punto1Coord[1]],
                                                 [celda.punto2Coord[0],celda.punto2Coord[1]],
                                                 [celda.punto4Coord[0],celda.punto4Coord[1]],
                                                 [(celda.punto4Coord[0] - celda.punto3Coord[0]) /2 + celda.punto3Coord[0],celda.punto3Coord[1]]]};
              }
              else{
                //Case 7
                if(celda.punto1>0 && celda.punto2>0 && celda.punto3<1 && celda.punto4>0){
                  caseCelda={type:1,case:7,i:celda.i,j:celda.j, polygonCoord:[[celda.punto1Coord[0],celda.punto1Coord[1]],
                                                   [celda.punto2Coord[0],celda.punto2Coord[1]],
                                                   [celda.punto4Coord[0],celda.punto4Coord[1]],
                                                   [(celda.punto4Coord[0] - celda.punto3Coord[0]) /2 + celda.punto3Coord[0],celda.punto3Coord[1]],
                                                   [celda.punto1Coord[0],(celda.punto3Coord[1] - celda.punto1Coord[1]) /2 + celda.punto1Coord[1]]]};
                }
                else{
                  //Case 8
                  if(celda.punto1<1 && celda.punto2<1 && celda.punto3>0 && celda.punto4<1){
                    caseCelda={type:1,case:8,i:celda.i,j:celda.j,polygonCoord:[[celda.punto1Coord[0],(celda.punto3Coord[1] - celda.punto1Coord[1]) /2 + celda.punto1Coord[1]],
                                                     [(celda.punto4Coord[0] - celda.punto3Coord[0]) /2 + celda.punto3Coord[0],celda.punto3Coord[1]],
                                                   [celda.punto3Coord[0],celda.punto3Coord[1]]]};
                  }
                  else{
                    //Case 9
                    if(celda.punto1>0 && celda.punto2<1 && celda.punto3>0 && celda.punto4<1){
                      caseCelda={type:1,case:9,i:celda.i,j:celda.j,polygonCoord:[[celda.punto1Coord[0],celda.punto1Coord[1]],
                                                       [(celda.punto2Coord[0] - celda.punto1Coord[0]) /2 + celda.punto1Coord[0],celda.punto1Coord[1]],
                                                       [(celda.punto4Coord[0] - celda.punto3Coord[0]) /2 + celda.punto3Coord[0],celda.punto3Coord[1]],
                                                     [celda.punto3Coord[0],celda.punto3Coord[1]]]};
                    }
                    else{

                      //Case 10
                      if(celda.punto1<1 && celda.punto2>0 && celda.punto3>0 && celda.punto4<1){
                        caseCelda={type:2,case:10,i:celda.i,j:celda.j,polygonCoord:[[(celda.punto2Coord[0] - celda.punto1Coord[0]) /2 + celda.punto1Coord[0],celda.punto1Coord[1]],
                                                         [celda.punto2Coord[0],celda.punto2Coord[1]],
                                                         [celda.punto2Coord[0],(celda.punto4Coord[1] - celda.punto2Coord[1]) /2 + celda.punto2Coord[1]]],
                                          polygonCoord2:[[celda.punto1Coord[0],(celda.punto3Coord[1] - celda.punto1Coord[1]) /2 + celda.punto1Coord[1]],
                                                         [(celda.punto4Coord[0] - celda.punto3Coord[0]) /2 + celda.punto3Coord[0],celda.punto3Coord[1]],
                                                       [celda.punto3Coord[0],celda.punto3Coord[1]]]};
                      }
                      else{
                        //Case 11
                        if(celda.punto1>0 && celda.punto2>0 && celda.punto3>0 && celda.punto4<1){
                          caseCelda={type:1,case:11,i:celda.i,j:celda.j,polygonCoord:[[celda.punto1Coord[0],celda.punto1Coord[1]],
                                                           [celda.punto2Coord[0],celda.punto2Coord[1]],
                                                           [celda.punto2Coord[0],(celda.punto4Coord[1] - celda.punto2Coord[1]) /2 + celda.punto2Coord[1]],
                                                           [(celda.punto4Coord[0] - celda.punto3Coord[0]) /2 + celda.punto3Coord[0],celda.punto3Coord[1]],
                                                         [celda.punto3Coord[0],celda.punto3Coord[1]]]};
                        }
                        else{
                          //Case 12
                          if(celda.punto1<1 && celda.punto2<1 && celda.punto3>0 && celda.punto4>0){
                            caseCelda={type:1,case:12,i:celda.i,j:celda.j,polygonCoord:[[celda.punto1Coord[0],(celda.punto3Coord[1] - celda.punto1Coord[1]) /2 + celda.punto1Coord[1]],
                                                             [celda.punto2Coord[0],(celda.punto4Coord[1] - celda.punto2Coord[1]) /2 + celda.punto2Coord[1]],
                                                             [celda.punto4Coord[0],celda.punto4Coord[1]],
                                                           [celda.punto3Coord[0],celda.punto3Coord[1]]]};
                          }
                          else{
                            //Case 13
                            if(celda.punto1>0 && celda.punto2<1 && celda.punto3>0 && celda.punto4>0){
                              caseCelda={type:1,case:13,i:celda.i,j:celda.j, polygonCoord:[[celda.punto1Coord[0],celda.punto1Coord[1]],
                                                               [(celda.punto2Coord[0] - celda.punto1Coord[0]) /2 + celda.punto1Coord[0],celda.punto1Coord[1]],
                                                               [celda.punto2Coord[0],(celda.punto4Coord[1] - celda.punto2Coord[1]) /2 + celda.punto2Coord[1]],
                                                               [celda.punto4Coord[0],celda.punto4Coord[1]],
                                                             [celda.punto3Coord[0],celda.punto3Coord[1]]]};
                            }
                            else{
                              //Case 14
                              if(celda.punto1<1 && celda.punto2>0 && celda.punto3>0 && celda.punto4>0){
                                caseCelda={type:1,case:14,i:celda.i,j:celda.j, polygonCoord:[[(celda.punto2Coord[0] - celda.punto1Coord[0]) /2 + celda.punto1Coord[0],celda.punto1Coord[1]],
                                                                 [celda.punto2Coord[0],celda.punto2Coord[1]],
                                                                 [celda.punto4Coord[0],celda.punto4Coord[1]],
                                                                 [celda.punto3Coord[0],celda.punto3Coord[1]],
                                                                 [celda.punto1Coord[0],(celda.punto3Coord[1] - celda.punto1Coord[1]) /2 + celda.punto1Coord[1]]]};
                              }
                              else {
                                //Case 15
                                if(celda.punto1>0 && celda.punto2>0 && celda.punto3>0 && celda.punto4>0){
                                  caseCelda={type:1,case:15,i:celda.i,j:celda.j, polygonCoord:[[celda.punto1Coord[0],celda.punto1Coord[1]],
                                                                   [celda.punto2Coord[0],celda.punto2Coord[1]],
                                                                   [celda.punto4Coord[0],celda.punto4Coord[1]],
                                                                   [celda.punto3Coord[0],celda.punto3Coord[1]]]};
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return caseCelda;
}

class UmapComponentColorBy extends Component {

  constructor(props){
    super(props)
    this.state = {
      flag:1,
      switchHighlighted:false, //swicth "Only Highlighted Data"
      switchContours:false,
      xMin:1000,
      xMax:-1000,
      yMin:1000,
      yMax:-1000,
      umap_data:[],
      umap_detrital:[],
    }
    this.updateNoSelectData = this.updateNoSelectData.bind(this);
    this.mountNoSelectData = this.mountNoSelectData.bind(this);
    this.updateDetritalData = this.updateDetritalData.bind(this);
    this.update_contours = this.update_contours.bind(this);
    this.view_contours = this.view_contours.bind(this);
  }


  //se invoca antes de renderizar cuando se reciben nuevas propiedades o estados
  componentDidUpdate(prevProps){


    if(prevProps.optionDropDown != this.props.optionDropDown ){
      //d3.select("#overlay-color").selectAll("*").remove();
      this.setState({switchContours:false});
      this.mountNoSelectData(this.props.optionDropDown);
    }

    if(!(prevProps.filteredData_projection.length == this.props.filteredData_projection.length) ||
        !(prevProps.filteredData_umap.length == this.props.filteredData_umap.length) ||
      !(prevProps.colorBy[0] == this.props.colorBy[0]) || !(prevProps.colorBy[1] == this.props.colorBy[1])){
          this.updateNoSelectData(this.props.optionDropDown,[this.state.xMin,this.state.xMax],[this.state.yMin,this.state.yMax]);
    }
  }

  saveSVG(svgEl,name){
        svgEl.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        var svgData = svgEl.outerHTML;
        var preface = '<?xml version="1.0" standalone="no"?>\r\n';
        var svgBlob = new Blob([preface, svgData], {type:"image/svg+xml;charset=utf-8"});
        var svgUrl = URL.createObjectURL(svgBlob);
        var downloadLink = document.createElement("a");
        downloadLink.href = svgUrl;
        downloadLink.download = name;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
  }

  mountNoSelectData(option){ //Cuando se invoca al mount, se inicializan los xmin, xmax,ymin, ymax para dibujar en el mayor espacio posible.

    let auxx = d3.extent(this.props.umap_data[option].map(l=>l.umap1));
    this.setState({xMin:auxx[0]});
    this.setState({xMax:auxx[1]});

    let auxy = d3.extent(this.props.umap_data[option].map(l=>l.umap2));
    this.setState({yMin:auxy[0]});
    this.setState({yMax:auxy[1]});

    this.updateNoSelectData(option,[auxx[0],auxx[1]],[auxy[0],auxy[1]]);
  }


  updateNoSelectData(option,x,y){

    var canvas = document.getElementById("umap-chart-color"),
    ctx = canvas.getContext("2d");

    var width = 500;
    var height = 500;
    if(screen.width>1800){
      width= 500;
      height= 350;
    }

    canvas.width = width//document.getElementById("container-UMAP").offsetWidth-20;
    canvas.height = height; //document.getElementById("container-UMAP").offsetHeight-20;

    var umap_data = []; //coordenadas de puntos del umap segun la opcion elegida en dropdown (x,y,categoria)
    var data = this.props.complete_data; //necesario para SubCategoria de los puntos
    var scaleColor = d3.scaleOrdinal()
    .domain(["Alaskan ultramafic","Alkali/Lamprophyres","Basalt","Komatiite","Layered intrusion","Metamorphic","Ophiolite","Xenoliths"])
    .range(["#ED1909","#1E90FF", "#F062CB", "#AA30FF", "#C0FF30", "#FF6347","#30FF40", "#304FFF"])
    //.range(["#ED1909","#F56101", "#1E90FF", "#41A321", "#0087F5", "#02318A","#833D9F", "#F59FD7"])

    var categoryOrder = d3.scaleOrdinal()
    .domain(["Alaskan ultramafic","Alkali/Lamprophyres","Basalt","Komatiite","Layered intrusion","Metamorphic","Ophiolite","Xenoliths"])
    .range([0,1,2,3,4,5,6,7])

    const subcats = [[],
    ["alkali basalt etc","kimberlite","lamproite"],
    ["boninite","flood basalt","hawaii lava lake","island arc","ocean floor","ocean island"],
    ["chromite cores amphibolite AUDK","chromite cores amphibolite ADK","chromite cores greenschist","sulphide"],
    ["chromitite","other","subvolc sills/dykes"],
    ["magnetite rims amphibolite","magnetite rims greenschist"],
    ["chromitite","high p alpine","ocean floor peridotite","chromite"],
    ["basalts","kimberlites"]];



    var xMin = x[0];
    var xMax = x[1];
    var yMin = y[0];
    var yMax = y[1];

    var selecc_data=[];
    var noselecc_data=[];
    var d;

    this.props.umap_data[option].map(item => {
        d = {i:item.i,umap1:((item.umap1-xMin)/(xMax-xMin)),umap2:((item.umap2-yMin)/(yMax-yMin)),Category:item.Category};
        selecc_data.push(d) ;
    });


    const subcategoryQuery = (id) =>{
      return data[id].Category2;
    };

    let switchHighlighted = this.state.switchHighlighted;
    let filteredData_projection = this.props.filteredData_projection;
    let filteredData_umap = this.props.filteredData_umap;

    var margin = {top: 10, right: 10, bottom: 10, left: 10},
    width = canvas.width,
    height = canvas.height;

    // Tamaño del punto en el scatterplot
    var pointSize = 1.5;

    // Add X axis
    var x = d3.scaleLinear()
    .domain([0, 1])
    .range([ 0+margin.left, width-margin.right]);


    // Add Y axis
    var y = d3.scaleLinear()
    .domain([0, 1])
    .range([ height-margin.bottom, 0+margin.top]);

    // Dibuja el scatterplot
    function drawScatterplot(props,data) {

        var colorScale;

        if(props.colorBy[0] == "Attribute"){
          var colorBy = props.colorBy[1];
          let auxx = d3.extent(data.map(l=>l[colorBy]));
          var min = parseFloat(auxx[0]);
          var max = parseFloat(auxx[1]);

          var colorScale = d3.scaleSequential().domain([min,max]).interpolator(d3.interpolateReds);
        }

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        //datos no seleccionados (grises)
        for (var i = 0; i < noselecc_data.length; i++) {
          var point = noselecc_data[i];
          ctx.beginPath();
          ctx.arc(x(point.umap1), y(point.umap2), pointSize, 0, 2 * Math.PI);
          ctx.fillStyle = "rgba(190,190,190,0.1)";
          ctx.fill();
          ctx.closePath();
          ctx.lineWidth = 0;
        }

        //Datos seleccionados (en umap o projecciones)
        for (var i = 0; i < selecc_data.length; i++) {
          var point = selecc_data[i];
          var c,cs;
          ctx.beginPath();
          ctx.arc(x(point.umap1), y(point.umap2), pointSize, 0, 2 * Math.PI);
          if(props.colorBy[0] == "Attribute"){
            c = colorScale(parseFloat(data[point.i][props.colorBy[1]]));
            //console.log(c);
          }



          ctx.globalAlpha = 0.5;
          ctx.fillStyle = c;
          ctx.fill();
          ctx.globalAlpha = 1;
          if(filteredData_projection.includes(point.i)){
            ctx.strokeStyle = "#B90E0A";
            ctx.lineWidth = 0.2;
            ctx.stroke();
          }

          else {
            if(filteredData_umap.includes(point.i)){
              ctx.strokeStyle = "#000000";
              ctx.lineWidth = 0.2;
              ctx.stroke();
            }
            else {
              ctx.lineWidth = 0;
            }
            ctx.closePath();
         }
       }
     }
      drawScatterplot(this.props,data);

      // lasso selection based on the drag events
      let coords = [];
      const lineGenerator = d3.line();

      const pointInPolygon = function (point, vs) {

          var x = point[0],
              y = point[1];

          var inside = false;
          for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
              var xi = vs[i][0],
                  yi = vs[i][1];
              var xj = vs[j][0],
                  yj = vs[j][1];

              var intersect =
                  yi > y != yj > y &&
                  x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
              if (intersect) inside = !inside;
          }

          return inside;
      };

      const drawPath = () =>  {

          d3.select("#lasso")
              .style("stroke", "black")
              .style("stroke-width", 1)
              .style("stroke-dasharray", 5)
              .style("fill", "#00000025")
              .attr("d", lineGenerator(coords));
      }

      const dragStart = () =>  {
          coords = [];
          d3.select("#lasso").remove();
          d3.select("#overlay")
              .append("path")
              .attr("id", "lasso");
      }

      const dragMove = (event) => {
          let mouseX = d3.event.sourceEvent.offsetX;
          let mouseY = d3.event.sourceEvent.offsetY;
          coords.push([mouseX, mouseY]);
          drawPath();
      }

      const dragEnd = () => {
          let selectedDots = [];

          ctx.clearRect(0, 0, width, height); // Clear canvas

          selecc_data.forEach(d => {
              let point = [
                  x(d.umap1),
                  y(d.umap2),
              ];

              if (pointInPolygon(point, coords)) {
                  //ctx.beginPath();
                  //ctx.arc(point[0], point[1], 5, 0, 2 * Math.PI); // Draw a circle for each data point
                  //ctx.fill();
                  selectedDots.push(d.i);
              }
          });
          this.props.cbk_filteredData_projection([]);
          this.props.cbk_filteredData_umap(selectedDots);

          selectedDots = [];

          this.state.umap_detrital.forEach(d => {
              let point = [
                  x(d.umap1),
                  y(d.umap2),
              ];

              if (pointInPolygon(point, coords)) {
                  //ctx.beginPath();
                  //ctx.arc(point[0], point[1], 5, 0, 2 * Math.PI); // Draw a circle for each data point
                  //ctx.fill();
                  selectedDots.push(d.i);
              }
          });
          this.props.cbk_filtered_Data_detrital(selectedDots);

      }

      const drag = d3
          .drag()
          .on("start", dragStart)
          .on("drag", dragMove)
          .on("end", dragEnd);

      d3.select("#overlay-color").call(drag);
      this.update_contours(this.props.optionDropDown);
  }

  updateDetritalData(props){

    d3.select("#overlay-color").selectAll(".detrital").remove()

    var svg = d3.select("#overlay-color")
    .append("g")

    var margin = {top: 10, right: 10, bottom: 10, left: 10},
      width = 500,
      height = 500;

    // Add X axis
    var x = d3.scaleLinear()
      .domain([0, 1])
      .range([ 0+margin.left, width-margin.right]);

    // Add Y axis
    var y = d3.scaleLinear()
      .domain([0, 1])
      .range([ height-margin.bottom, 0+margin.top]);


    let umap_detrital = [],detritalId = [];
    var xMin = this.state.xMin;
    var xMax = this.state.xMax;
    var yMin = this.state.yMin;
    var yMax = this.state.yMax;

    this.props.umap_detrital.forEach(function(item, i) {
        umap_detrital.push({
          i:item.i,
          Ref:item.Ref,
          umap1:(item.umap1-xMin)/(xMax-xMin),
          umap2:(item.umap2-yMin)/(yMax-yMin),
          cat:item.Category,
          id:item.id});
    });

    this.setState({umap_detrital:umap_detrital});
    //detrital
    // Add dots
    const symbol = [d3.symbolCross,d3.symbolSquare,d3.symbolCircle,d3.symbolDiamond2, d3.symbolTriangle, d3.symbolStar, d3.symbolCircle,d3.symbolCross];
    let filteredData_detrital = this.props.filteredData_detrital;

    var detrital = svg.append('g')
      .selectAll("dot")
      .data(umap_detrital)
      .enter()
      .append("path")
      .attr("class", "detrital")
      .attr("d", d3.symbol().type( function(d,i){
        return symbol[d.id];
      }).size(20))
      .attr("transform", function(d) { return "translate(" + x(d.umap1) + "," + y(d.umap2) + ")"; })
      .style("fill", "black")
      .style("stroke",null)
      //.on("mouseover", (d, i, nodes) => {mouseover(d)} )
	    //.on("mouseout", (d, i, nodes) => {mouseout(d)} )
      .on("click", (d, i, nodes) => {
        if(event.ctrlKey) {
          if(d3.select(nodes[i]).style("stroke")=="#000000"){ //Si el detrito ya esta seleccionado
            d3.select(nodes[i])
              .style("fill","rgba(0, 0, 0, 1)")
              .style("stroke", null)
          }
          else {
            d3.select(nodes[i])
              .style("fill","rgba(255, 255, 255, 1)")
              .style("stroke", "#000000")
          }
          clkSeleccDetrital(d.i);
        }
      });

      const clkSeleccDetrital=(d)=>{
        this.props.clkSeleccDetrital(d);
      }
  }

  updateSelectDetritalData(props){
    let filteredData_detrital = props.filteredData_detrital;

    d3.select("#overlay-color").selectAll(".detrital")
    .style("fill",function(d,i){
      if(filteredData_detrital.includes(d.i)) return  "#FFFFFF";
      else return "#000000";
    })
    .style("stroke",function(d,i){
      if(filteredData_detrital.includes(d.i)) return  "#000000";
      else return null;
    })
    .classed("selected_detrital",function(d,i){
      if(filteredData_detrital.includes(d.i)) return  true;
      else{
        return false;
      }
    })
    d3.select("#overlay-color").selectAll(".selected_detrital").raise();
  }

  /*
  * Método para dibujar el UMAP
  */

  update_contours(option){
    /////////////////////////////////CONTORNOS//////////////////////////////////////////////////////////////

      d3.select("#overlay-color").selectAll(".contours").remove()
      var svg = d3.select("#overlay-color").append("g")

      var margin = {top: 10, right: 10, bottom: 10, left: 10},
        width = 500,
        height = 500;

        // Add X axis
        var x = d3.scaleLinear()
        .domain([0, 1])
        .range([ 0+margin.left, width-margin.right]);

        // Add Y axis
        var y = d3.scaleLinear()
        .domain([0, 1])
        .range([ height-margin.bottom, 0+margin.top]);

      let data_contour  = [d3.range(0,385),d3.range(386,2738),d3.range(2739,7905),d3.range(7906,11017),d3.range(11018,15245),d3.range(15246,16901),d3.range(16902,22350),d3.range(22351,24589)];
      let colour_contour = ["#ED1909","#1E90FF", "#F062CB", "#AA30FF", "#C0FF30", "#FF6347","#30FF40", "#304FFF"];

      let percentiles = [90,50];
      let arrayCuad = [];
      let subData = [];
      let sortP = [];
      let contours = [];
      let d= [];
      let umap_data= [];
      var xMin = this.state.xMin;
      var xMax = this.state.xMax;
      var yMin = this.state.yMin;
      var yMax = this.state.yMax;

      this.props.umap_data[option].forEach(function(item, i) {
          umap_data.push({i:item.i,umap1:((item.umap1-xMin)/(xMax-xMin)),
            umap2:((item.umap2-yMin)/(yMax-yMin)),Category:item.Category});
      });


      data_contour.forEach((item,index) => {
        if(this.props.selecc_category.length>0 && this.props.selecc_category.includes(umap_data[item[0]].Category)){
          for(let j = 0; j<item.length; j++){
            d.push(umap_data[item[j]]);
          }

          percentiles.forEach(percentil => {
            sortP = sortPoints(d);
            subData = subDataFunction(sortP,percentil); ////ver de sortPoints calcularlo c vez q se cambia de dataset nada mas
            arrayCuad = MarchingSquares2D(subData,percentil);

            contours=[];

            for(let i = 0; i< arrayCuad.length; i++){
              //Solo los no recorridos
              if(arrayCuad[i].type === 1){
                contours.push(arrayCuad[i].polygonCoord);
              }
              else{
                if(arrayCuad[i].type === 2 ){
                  contours.push(arrayCuad[i].polygonCoord);
                  contours.push(arrayCuad[i].polygonCoord2);
                }
              }
            }
            const curve = d3.line().curve(d3.curveLinearClosed);
            //const curve = d3.line().curve(d3.curveCardinalClosed);
            //const curve = d3.line().curve(d3.curveLinearClosed);

            let visibility = 'hidden';
            if(this.state.switchContours)
              visibility = 'visible';
            let contorno = [];
            if(contours.length>0){
              for(let i=0; i< contours.length; i++){
                for(let j=0; j< contours[i].length; j++){
                  contorno.push([x(contours[i][j][0]),y(contours[i][j][1])]);
                }
                svg.append('path')
                .attr('d', curve(contorno))
                .attr("class", "contours")
                .attr("fill", colour_contour[index])
                .attr("opacity",0.1)
                .style("visibility",visibility)
                .attr('stroke',colour_contour[index])
                .attr('stroke-opacity',0)
                contorno = [];
              }
            }
          });
        }


        d=[];
      });
  }

  view_contours(){
    let switchContours = !this.props.view_contours;
    if(!switchContours){
      d3.select("#overlay-color").selectAll(".contours")
        .style("visibility",'visible');//to hide
    }
    else {
      d3.select("#overlay-color").selectAll(".contours")
        .style("visibility",'hidden');//to show

    }
    this.setState({switchContours:!switchContours});
  }

  render(){

    return (
      <div >
        <div id="container-UMAP-color" >
          <canvas id="umap-chart-color"></canvas>
          <svg id="overlay-color"></svg>
        </div>
      </div>
    );
  }
}
/*

<text class="textSwitch" >Colorize unselected items</text>

<Switch checked={this.state.switch} onChange={e =>{this.setState({switch:!this.state.switch},()=>this.update_UMAP(this.props.dropDownOption)); }}/>
*/
export default UmapComponentColorBy;
